// TimeZone Enums --------------------------------------------------------------------------------------------------------------------------

// Declare the TimeZone enumerated values

export enum TimeZoneFields {
  Country = "country",
  CountryId = "country_id",
  CountryName = "country_name",
  CreatedAt = "created_at",
  Description = "description",
  Id = "id",
  UpdatedAt = "updated_at",
  Zone = "zone",
}

// TimeZone Interfaces ---------------------------------------------------------------------------------------------------------------------

export interface TimeZone {
  [TimeZoneFields.CountryId]: number;
  [TimeZoneFields.CreatedAt]: string | null;
  [TimeZoneFields.Description]: string;
  [TimeZoneFields.Id]: number;
  [TimeZoneFields.UpdatedAt]: string | null;
  [TimeZoneFields.Zone]: string;
}

export interface TimeZoneCrud {
  [TimeZoneFields.CountryId]: number;
  [TimeZoneFields.Description]: string;
  [TimeZoneFields.Id]: number | null;
  [TimeZoneFields.Zone]: string;
}

export interface TimeZoneDetail {
  [TimeZoneFields.Country]: string;
  [TimeZoneFields.CreatedAt]: string | null;
  [TimeZoneFields.Description]: string;
  [TimeZoneFields.Id]: number;
  [TimeZoneFields.UpdatedAt]: string | null;
  [TimeZoneFields.Zone]: string;
}
